import { render, staticRenderFns } from "./OptionGroupsModal.vue?vue&type=template&id=febddc72&scoped=true"
import script from "./OptionGroupsModal.vue?vue&type=script&lang=js"
export * from "./OptionGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./OptionGroupsModal.vue?vue&type=style&index=0&id=febddc72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febddc72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('febddc72')) {
      api.createRecord('febddc72', component.options)
    } else {
      api.reload('febddc72', component.options)
    }
    module.hot.accept("./OptionGroupsModal.vue?vue&type=template&id=febddc72&scoped=true", function () {
      api.rerender('febddc72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/goods/OptionGroupsModal.vue"
export default component.exports